const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',')

export function getFocusable(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter(el => el.getClientRects().length > 0)
}

/**
 * Constrains keyboard focus (Tab / Shift+Tab) to within `container`.
 * Returns { activate, deactivate }. Safe to call activate/deactivate repeatedly.
 */
export function createFocusTrap(container) {
    let active = false

    const handler = (e) => {
        if (e.key !== 'Tab') return

        const focusable = getFocusable(container)
        if (!focusable.length) return

        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        const current = document.activeElement

        // Focus is on the container wrapper or has drifted outside the trap:
        // pull it back to the appropriate edge.
        if (focusable.indexOf(current) === -1) {
            e.preventDefault()
            ;(e.shiftKey ? last : first).focus()
            return
        }

        if (e.shiftKey && current === first) {
            e.preventDefault()
            last.focus()
        } else if (!e.shiftKey && current === last) {
            e.preventDefault()
            first.focus()
        }
    }

    return {
        activate() {
            if (active) return
            active = true
            // Capture phase so the trap runs before other Tab handlers.
            document.addEventListener('keydown', handler, true)
        },
        deactivate() {
            if (!active) return
            active = false
            document.removeEventListener('keydown', handler, true)
        }
    }
}